<template>
    <div class="cashback-content">
        <div class="order-content-list" v-infinite-scroll="load" infinite-scroll-disabled="disabled"
            infinite-scroll-distance="20" infinite-scroll-immediate="false">
            <div class="order-content-each" v-for="(item, value) in rows" :key="value">
                <div class="record-head">
                    <div class="record-id">账单号：{{ item.id }}</div>
                    <div class="record-status blue" v-if="item.status === '0'">审核中</div>
                    <div class="record-status green" v-if="item.status === '1'">通过</div>
                    <div class="record-status green" v-if="item.status === '2'">提现成功</div>
                    <div class="record-status red" v-if="item.status === '3'">驳回</div>
                </div>
                <div class="record-info">
                    <div class="record-time">申请时间：{{ item.createTime ? formattedDateTime(item) : '' }}</div>
                    <div class="record-bankNo">银行卡：{{ item.bankNo }}</div>
                    <div class="record-count">
                        <div class="record-count-left">申请金额：{{ item.applyTotal }}</div>
                        <div class="record-count-right">实际到账：{{ item.realityTotal }}</div>
                    </div>
                </div>
            </div>
            <!-- 下拉加载时候加loading旋转动效 -->
            <div v-if="loading" style="margin-top:10px;" class="loading">
                <span>loding...</span>
            </div>
        </div>
    </div>
</template>
<script>
import { listStudentDrawRecord } from '@/api/common'
export default {
    name: 'CashbackRecordPage',
    props: ['id'],
    data() {
        return {
            merchantId: '',
            rows: [],
            pageNum: 1,
            pageSize: 8,
            loading: false,
        }
    },
    mounted() {
        this.merchantId = this.id;
        this.getCashbackOrderList();
    },
    methods: {
        //  0：审核中 1：通过 2：提现成功 3：驳回
        getCashbackOrderList() {
            let params = {
                'pageSize': this.pageSize,
                'pageNum': this.pageNum,
                'orderByColumn': 'create_time desc,id',
                'isAsc': 'desc'
            };
            listStudentDrawRecord(params).then((res) => {
                if (res.code === 200) {
                    this.rows = this.rows.concat(res.rows);
                    this.pages = Math.ceil(res.total / this.pageSize);
                    // this.sumCashback = res.sumCashback || 0;
                    // this.balance = res.balance || 0;
                }
            })
        },
        load() {
            //滑到底部时进行加载
            this.loading = true;
            let params = {
                'pageSize': this.pageSize,
                'pageNum': this.pageIndex + 1,
                'orderByColumn': 'create_time desc,id',
                'isAsc': 'desc'
            };
            listStudentDrawRecord(params).then((res) => {
                this.rows = this.rows.concat(res.rows);
                this.pageIndex++
                this.loading = false;
            })
        },
        formattedDateTime(item) {
            return this.$formatDateTime(new Date(item.createTime), 'YYYY-MM-DD HH:mm');
        },
    }
}
</script>

<style scoped>
.cashback-content {
    height: 100vh;
    background-color: #f5f5f5;
    overflow: hidden;
}

.order-content-list {
    height: 100%;
    overflow-y: auto;
}

.order-content-each {
    padding: 15px;
    margin-bottom: 1px;
    min-height: 110px;
    background-color: #fff;
}

/* 加载时候转圈的动效 */
.loading {
    text-align: center;
}

.loading span {
    display: inline-block;
    font-size: 14px;
    color: #666;
}

.record-head {
    display: flex;
    justify-content:space-between;
    align-items: center;
    padding-bottom: 10px;
    border-bottom: 1px solid #E5E5E5;
}

.record-id {
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 500;
}

.record-status {
    margin-right: 5px;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    letter-spacing: 0;
    font-weight: 500;
}

.record-status.blue {
    color: #0095D9;
}

.record-status.red {
    color: #F11515;
}

.record-status.green {
    color: #13D275;
}

.record-info {
    overflow: hidden;
}

.record-time,
.record-bankNo {
    margin-top: 10px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    text-align: left;
    font-weight: 400;
}

.record-count {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.record-count-left {
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #0095D9;
    letter-spacing: 0;
    font-weight: 500;
}

.record-count-right {
    margin-right: 9px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #6D7278;
    letter-spacing: 0;
    font-weight: 500;
}
</style>